<ion-app [class]="tenant">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
